import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '@/store';

Vue.use(VueAxios, axios);
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.baseURL = 'http://dev-passport.caocaokeji.cn/uc-passport'; // 开发环境
// axios.defaults.baseURL = 'https://uc-api.caocaoglobal.com/uc-passport'; // 生成环境

axios.interceptors.request.use((request) => {
  const language = {
    'zh-CN': 'zh-CN,zh;q=0.9,en-US;q=0.8,en;q=0.7',
    en: 'en-US,en;q=0.9,zh-CN;q=0.8,zh;q=0.7'
  }[store.state.language];

  if (language) {
    request.headers['Accept-Language'] = language;
  }

  return request;
});

axios.interceptors.response.use((response) => {
  const { data = {}, status, statusText } = response;
  let message;

  if (data.code) {
    // Create an unified error code in constant case.
    // For example: unknown-error => UNKNOWN_ERROR
    data.CODE = data.code
      .replace(/([a-z])([A-Z])/g, '$1_$2')
      .replace(/\W+/g, '_')
      .toUpperCase();
  }

  if (status >= 200 && status < 300) {
    if (data.code !== 'success') {
      ({ message } = data);
    }
  } else {
    message = data.message || statusText;
  }

  if (message) {
    const error = new Error(message);

    error.code = data.code;
    error.CODE = data.CODE;
    error.data = data.data;
    error.response = response;
    throw error;
  }

  return data;
});

export default axios;
